<div [formGroup]="form()" class="grid grid-cols-2 gap-4 md:grid-cols-4">
  @for (item of items(); track item.field) {
    <aura-button-card [label]="item.label" [selected]="isActive(item.field)" (clicked)="onToggle(item.field)">
      <mat-icon icon>{{ item.icon }}</mat-icon>
    </aura-button-card>
  }
</div>
